function About() {
  return (
    <div className="bg-navy-light py-20 px-8" id="about">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-light mb-2">
          <span className="text-green font-mono text-xl">01. </span>
          About Me
        </h2>
        <div className="w-64 h-px bg-navy-lighter mb-10"></div>
        <p className="text-slate mb-4">
          Cloud Operations and SRE professional with 10+ years of experience
          in production reliability, observability, and incident management.
        </p>
        <p className="text-slate mb-4">
          Previously at Samsung SDS supporting a global D2C e-commerce platform,
          owning ELK Stack monitoring, incident management, and CI/CD pipeline support.
          Reduced MTTR by 25% through structured log-based observability.
        </p>
        <p className="text-slate">
          Currently building hands-on DevOps skills through GaadiyaHub —
          a live vehicle marketplace running on K3s Kubernetes on AWS.
        </p>
      </div>
    </div>
  );
}

export default About;